import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index.js'
import './assets/css/global.css'
import './assets/css/initialization.css'
import * as common from '@/utils/common'
Vue.prototype.common = common
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import * as echarts4 from 'echarts4'
import 'echarts-wordcloud'
import * as config from '@/utils/config'
import { getUrl } from './utils/config'
import defotquery from './utils/query'
import { setLocaData, getLocaData } from '@/utils/common'
import './utils/rem.js'
import axios from 'axios'
import './utils/axios'
import Bus from '../src/utils/bus'
import versionConfig from './config'

import moment from 'moment'
import VideoPlayer from 'vue-video-player' // 视频插件引用
import 'vue-video-player/src/custom-theme.css' // 视频样式
import 'video.js/dist/video-js.css' // 视频插件样式
import scroll from 'vue-seamless-scroll'
import Paginate from 'vuejs-paginate'
import Pagination from '@/components/Pagination'   // 组件路径
import Pagination2 from '@/components/Pagination2'   // 组件路径
import VueCountUp from 'vue-countupjs'
import '@/assets/theme/index.css'
Vue.use(VueCountUp)
Vue.component(Pagination.name, Pagination)
Vue.component(Pagination2.name, Pagination2)
require('./mock/index');
Vue.component('paginate', Paginate)
Vue.use(scroll, { componentName: 'scroll-seamless' })
Vue.use(scroll)
Vue.use(VideoPlayer)
Vue.prototype.$moment = moment
Vue.prototype.$axios = axios
Vue.prototype.$defotquery = defotquery;
Vue.prototype.getUrl = getUrl
Vue.use(ElementUI);
Vue.prototype.config = config
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts
Vue.prototype.$echarts4 = echarts4
Vue.prototype.$versionConfig = versionConfig;
Vue.prototype.$bus = Bus;


//定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function (input, fmtstring) {//当input为时间戳时，需转为Number类型
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).format(fmtstring);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
if (config.baseUrl == 'https://sit.foshoaff.com') {

} else if (config.baseUrl == 'https://api.foshobrands.com') {
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?85b14a02ffc759779052b643559d96d2";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
router.beforeEach((to, from, next) => {
  let permitList = getLocaData('permitList')
  if (permitList) {
    permitList.forEach(item => {
      if (item.routAddr == to.path && item.permits.length < 1) {
        setLocaData('isSelect', item.title)
        setLocaData('isemitco', '')
        setLocaData('validParam', item.validParam)
      }
      if (item.permits.length > 0) {
        item.permits.forEach(item2 => {
          if (item2.routAddr == to.path) {
            setLocaData('isSelect', item.title)
            setLocaData('isemitco', item2.title)
            setLocaData('validParam', item2.validParam)
          }
        })
      }
    })
    if (to.path == '/info') {
      setLocaData('isSelect', -1)
      setLocaData('isemitco', '')
      setLocaData('validParam', '')
    }
  }
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
// var _hmt = _hmt || [];
// window._hmt = _hmt;
// (function() {
//   var hm = document.createElement("script");
//   hm.src = "https://hm.baidu.com/hm.js?0805dce2d04eeab5b0cc9b517075cb20";
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(hm, s);
// })();